"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _arkReact = require("@dateam/ark-react");
var _utils = require("../utils");
var _ModalBody = _interopRequireDefault(require("./ModalBody"));
var _ModalHeader = _interopRequireDefault(require("./ModalHeader"));
var _ModalFooter = _interopRequireDefault(require("./ModalFooter"));
var _ModalTitle = _interopRequireDefault(require("./ModalTitle"));
const Modal = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    id,
    className,
    backdrop,
    children,
    centered
  } = _ref;
  const onClickOutside = () => void {};
  _react.default.useEffect(() => {
    document.body.classList.add('dialog-overflow');
    return () => {
      document.body.classList.remove('dialog-overflow');
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(_utils.DomContainer, null, /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    className: (0, _arkReact.concatClassName)('modal', centered ? 'modal-center' : null)
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: id,
    className: (0, _arkReact.concatClassName)('modal-content', className)
  }, children)), backdrop === true && /*#__PURE__*/_react.default.createElement("div", {
    role: "button",
    className: "modalBackdrop",
    onClick: onClickOutside,
    "aria-hidden": "true",
    "aria-label": "drop"
  }));
});
process.env.NODE_ENV !== "production" ? Modal.propTypes = {
  id: _propTypes.default.string,
  className: _propTypes.default.string,
  backdrop: _propTypes.default.bool,
  children: _propTypes.default.node,
  centered: _propTypes.default.bool
} : void 0;
Modal.defaultProps = {
  id: undefined,
  className: undefined,
  backdrop: false,
  children: undefined,
  centered: false
};
var _default = exports.default = Object.assign(Modal, {
  Body: _ModalBody.default,
  Footer: _ModalFooter.default,
  Header: _ModalHeader.default,
  Title: _ModalTitle.default
});